import type { Ctx } from "../../types";
import { FormAction, invalidate, removeQueryParams } from "gg-wf-scripts";
import { toast } from "../../toast";
import { invokeApi, parse } from "../_helpers";
import { job_opening_schema } from "./_schema";

export const create_job_opening: FormAction<Ctx> = async (
  { sb },
  formData,
  _params
) => {
  const parsed = parse(job_opening_schema, formData);
  if (!parsed.ok) return parsed;

  const { school, draft, custom_time, ...rest } = parsed.data;
  const body = {
    ...rest,
    school_id: school,
    job_status: draft ? "draft" : "open",
    ...(custom_time ? { shift_type: "custom" as const } : {}),
  };

  const result = await invokeApi(sb, "api/jobs", {
    method: "POST",
    body,
  });
  if (!result.ok) return result;
  invalidate("jobs");
  removeQueryParams(["modal", "id"]);
  toast({ variant: "success", text: draft ? "Draft saved!" : "Job created!" });
  return result;
};
